import React from "react";
import styled from "styled-components";
import moment from "moment/moment";

const PickerContainer = styled.div`
    margin: 1rem 0 2rem;
    background: white;
    padding: 1.25rem 1.5rem;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    max-width: 520px;
`;

const YearRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    margin-bottom: 1rem;
`;

const NavButton = styled.button`
    background: #f5f5f5;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 0.5rem 0.85rem;
    cursor: pointer;
    font-size: 1rem;
    line-height: 1;

    &:hover {
        background: #eee;
    }
`;

const YearLabel = styled.h3`
    margin: 0;
    min-width: 80px;
    text-align: center;
    color: #333;
    font-size: 1.25rem;
`;

const MonthGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(3, 1fr);
    gap: 0.75rem;
`;

const MonthBrick = styled.button<{ $selected: boolean }>`
    padding: 1rem 0.5rem;
    border: 2px solid ${props => props.$selected ? "#4CAF50" : "#ddd"};
    border-radius: 8px;
    background: ${props => props.$selected ? "#e8f5e9" : "#fafafa"};
    color: ${props => props.$selected ? "#2e7d32" : "#333"};
    font-size: 0.95rem;
    font-weight: ${props => props.$selected ? 600 : 500};
    cursor: pointer;
    transition: all 0.15s ease;

    &:hover {
        border-color: #4CAF50;
        background: ${props => props.$selected ? "#e8f5e9" : "#f0f7f0"};
    }
`;

interface ReviewMonthCalendarProps {
    currentDate?: Date;
    onMonthChange?: (date: Date) => void;
}

const MONTHS = Array.from({ length: 12 }, (_, index) => ({
    value: index + 1,
    label: moment().month(index).format("MMMM"),
}));

const ReviewMonthCalendar: React.FC<ReviewMonthCalendarProps> = ({
    currentDate,
    onMonthChange,
}) => {
    const selectedDate = currentDate ?? new Date();
    const selectedMonth = selectedDate.getMonth() + 1;
    const selectedYear = selectedDate.getFullYear();

    const setMonthYear = (month: number, year: number) => {
        onMonthChange?.(new Date(year, month - 1, 1));
    };

    const shiftYear = (offset: number) => {
        setMonthYear(selectedMonth, selectedYear + offset);
    };

    return (
        <PickerContainer>
            <YearRow>
                <NavButton type="button" onClick={() => shiftYear(-1)} aria-label="Previous year">
                    ‹
                </NavButton>
                <YearLabel>{selectedYear}</YearLabel>
                <NavButton type="button" onClick={() => shiftYear(1)} aria-label="Next year">
                    ›
                </NavButton>
            </YearRow>

            <MonthGrid>
                {MONTHS.map(({ value, label }) => (
                    <MonthBrick
                        key={value}
                        type="button"
                        $selected={selectedMonth === value}
                        onClick={() => setMonthYear(value, selectedYear)}
                    >
                        {label}
                    </MonthBrick>
                ))}
            </MonthGrid>
        </PickerContainer>
    );
};

export default ReviewMonthCalendar;
